export const LEARNING_COMMONS_STANDARDS_URL =
  'https://docs.learningcommons.org/knowledge-graph/datasets/standards/us-academic-standards';

export function standardLabel(jurisdiction: string, statementCode: string): string {
  if (jurisdiction.trim().toLowerCase() !== 'texas') return statementCode;
  const match = /^111\.([2-7])\.b\.(\d+)\.([A-Z])$/i.exec(statementCode.trim());
  if (!match) return statementCode;
  const grade = Number(match[1]) - 2;
  return `TEKS ${grade === 0 ? 'K' : grade}.${match[2]}(${match[3]!.toUpperCase()})`;
}
